export const styles = {
  body: {
    backgroundColor: 'warning.light',
    width: '100%',
    height: '46px',
    position: 'fixed',
    zIndex: 1102,
  },
  button: {
    color: 'common.white',
    backgroundColor: 'warning.main',
    borderColor: 'common.white',
    border: 'none',
    '&:hover': {
      border: 'none',
    },
  },
};
